const PencilIcon = ({ style = {} }: { style?: React.CSSProperties }) => {
  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15.2898 11.1936L12.8064 8.71021M5.66663 18.3333L7.7678 18.0999C8.02451 18.0713 8.15287 18.0571 8.27284 18.0182C8.37928 17.9838 8.48058 17.9351 8.57398 17.8735C8.67926 17.804 8.77058 17.7128 8.95322 17.5301L17.1523 9.33105C17.8381 8.64529 17.8381 7.53344 17.1523 6.84767C16.4666 6.1619 15.3547 6.1619 14.6689 6.84767L6.46983 15.0467C6.28719 15.2293 6.19587 15.3207 6.12645 15.426C6.06486 15.5193 6.01617 15.6206 5.98171 15.7271C5.94288 15.8471 5.92861 15.9754 5.90009 16.2321L5.66663 18.3333Z"
        stroke="#69757D"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default PencilIcon
